import RequestClient from '@shared/services/main/request-client';
import UrlModifier from '@shared/lib/helpers/url-modifier';

/**
 * This prototype describes an read events trait. Encapsulate business logics
 *
 * @class      ReadCallable (name)
 */
function ReadCallable(component) {
  this.component = component;
}


ReadCallable.prototype.perpareReadParam = function(item_key = 'id', item_id) {
  var params = {};
  params[item_key] = item_id;
  return params;
}

/**
 * Registers Read events, this follows naming convention
 *
 * Let us allow this to accept a callback so we can override success
 * destination/logic
 *
 * @param      {Object}        self     The caller instance
 * @param      {ReadCallable}  service  The service
 * @param      {string}  module_name  The module name
 * @return     {Object}        { description_of_the_return_value }
 */
ReadCallable.prototype.registerReadEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.READ_PROCEED] = 'onReadProceed';
  event_callback_map[this.event_group.READ_SUCCESS] = 'onReadSuccess';
  event_callback_map[this.event_group.READ_FAIL]    = 'onReadFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Read events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
ReadCallable.prototype.removeReadEvents = function() {
  this.removeEvents([
    this.event_group.READ_PROCEED,
    this.event_group.READ_SUCCESS,
    this.event_group.READ_FAIL
  ]);
  return this;
}

/**
 * Gives the request extra options,
 *
 * NOTE: this will override the same option keys
 *
 * @return     {Object}  The request extra options
 */
ReadCallable.prototype.extraReadOptions = function() {
  return {};
}

/**
 * Called when read proc
 *
 * @param      {Object}  arg1         The argument 1
 * @param      {String}  arg1.url     The url
 * @param      {Object}  arg1.params  The parameters
 */
ReadCallable.prototype.onReadProceed = function({item_key='id', item_id}) {
  var url = UrlModifier.bindToUrl(
    this.read_endpoint,
    this.perpareReadParam(item_key, item_id)
  );

  let token_source = this.renewCancelToken(RequestClient, this.event_group.READ_PROCEED);
  this.getComponent().setState({loader: true});

  const options = this.extraReadOptions();
  let request = RequestClient.get(url, {
    cancelToken: token_source.token,
    ...options
  });
  this.bindResultEvents(
    request,
    this.event_group.READ_SUCCESS,
    this.event_group.READ_FAIL
  );
}

/**
 * Called on read success.
 *
 * @param      {Object}  response  The response
 */
ReadCallable.prototype.onReadSuccess = function(response) {
  this.getComponent().setState({item: response.data});
}

/**
 * Called on read fail.
 *
 * @param      {Object}  error   The error
 */
ReadCallable.prototype.onReadFail = function(error) {
  console.log("ReadCallable::onReadFail" , error);
}

export default ReadCallable;
